import React from "react";
import { Stack } from "@mui/material";

// v2: contenedor plano — sin borde degradado ni glow (docs/IDENTIDAD_VISUAL.md §6).
const NeonBox = (props) => {
  return (
    <Stack direction="column"
      sx={{
        width: {
          xs: "94%",  // 📱 Celulares
          sm: "90%",  // 🧩 Tablets
          md: "80%",  // 💻 PC
        },
        height: "auto",
        minHeight: 800,
        margin: {
          xs: "8px auto",
          sm: "32px auto",
          md: "48px auto"
        },
        display: "block",
        position: "relative",
        color: "text.primary",
      }}
    >
      {props.children}
    </Stack>
  );
};

export default NeonBox;
